// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: jYhYijvMje

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Header from "../../Header"; // plasmic-import: FX7sJMOvuD/component
import Footer from "../../Footer"; // plasmic-import: WRs9bMrYcz/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicPrivacyPolicyPage.module.css"; // plasmic-import: jYhYijvMje/css

createPlasmicElementProxy;

export type PlasmicPrivacyPolicyPage__VariantMembers = {};
export type PlasmicPrivacyPolicyPage__VariantsArgs = {};
type VariantPropType = keyof PlasmicPrivacyPolicyPage__VariantsArgs;
export const PlasmicPrivacyPolicyPage__VariantProps =
  new Array<VariantPropType>();

export type PlasmicPrivacyPolicyPage__ArgsType = {};
type ArgPropType = keyof PlasmicPrivacyPolicyPage__ArgsType;
export const PlasmicPrivacyPolicyPage__ArgProps = new Array<ArgPropType>();

export type PlasmicPrivacyPolicyPage__OverridesType = {
  root?: p.Flex<"div">;
  header?: p.Flex<typeof Header>;
  h1?: p.Flex<"h1">;
  privacyPolicy?: p.Flex<"div">;
  footer?: p.Flex<typeof Footer>;
};

export interface DefaultPrivacyPolicyPageProps {
  className?: string;
}

const $$ = {};

function PlasmicPrivacyPolicyPage__RenderFunc(props: {
  variants: PlasmicPrivacyPolicyPage__VariantsArgs;
  args: PlasmicPrivacyPolicyPage__ArgsType;
  overrides: PlasmicPrivacyPolicyPage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("__wab_instance", sty.header)}
          />

          <div className={classNames(projectcss.all, sty.freeBox___7J2CN)}>
            <div className={classNames(projectcss.all, sty.freeBox___6GaSd)}>
              <h1
                data-plasmic-name={"h1"}
                data-plasmic-override={overrides.h1}
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  projectcss.__wab_text,
                  sty.h1
                )}
              >
                {hasVariant(globalVariants, "screen", "mobileOnly") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#000000" }}
                    >
                      {"Privacy Policy"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#000000" }}
                    >
                      {"Privacy Policy"}
                    </span>
                  </React.Fragment>
                )}
              </h1>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__uBpGv)}>
              <div
                data-plasmic-name={"privacyPolicy"}
                data-plasmic-override={overrides.privacyPolicy}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.privacyPolicy
                )}
              >
                {hasVariant(globalVariants, "screen", "mobileOnly")
                  ? 'At ResourcePal, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard the information you provide to us through our website [www.resourcepal.io] (hereinafter referred to as the "Site").'
                  : 'At ResourcePal, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard the information you provide to us through our website [www.resourcepal.io] (hereinafter referred to as the "Site").'}
              </div>
              <h5
                className={classNames(
                  projectcss.all,
                  projectcss.h5,
                  projectcss.__wab_text,
                  sty.h5__dLid
                )}
              >
                {"Information Collection and Use:"}
              </h5>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__cYgjR
                )}
              >
                {
                  "We may collect personal information from you when you visit our Site, register an account, place an order, subscribe to our newsletter, or engage in other activities or services available on our Site. The information we may collect includes your name, email address, mailing address, phone number, and any other information voluntarily provided by you. We use this information to process your requests, provide customer support, deliver products or services, send promotional emails, and enhance your overall experience on our Site."
                }
              </div>
              <h5
                className={classNames(
                  projectcss.all,
                  projectcss.h5,
                  projectcss.__wab_text,
                  sty.h5__if9D6
                )}
              >
                {"Information Protection and Security:"}
              </h5>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__auwmF
                )}
              >
                {
                  "We take reasonable measures to protect the confidentiality, integrity, and security of your personal information. We utilize appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online. However, please be aware that no transmission of data over the internet or electronic storage method is 100% secure. While we strive to protect your personal information, we cannot guarantee its absolute security."
                }
              </div>
              <h5
                className={classNames(
                  projectcss.all,
                  projectcss.h5,
                  projectcss.__wab_text,
                  sty.h5__uBuO
                )}
              >
                {"Information Sharing and Third Parties:"}
              </h5>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___3P8Ze
                )}
              >
                {
                  "We do not sell, trade, or rent your personal information to third parties for marketing purposes. However, we may share your information with trusted third-party service providers who assist us in operating our website, conducting business, or servicing you. These parties are contractually obligated to keep your information confidential and are prohibited from using your personal information for any other purpose. We may also disclose your information to comply with legal requirements, enforce our site policies, or protect our or others' rights, property, or safety."
                }
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__bOhu6
                )}
              >
                {
                  "By using our Site, you consent to the terms of this Privacy Policy and acknowledge that you have read and understood its contents. This Privacy Policy applies only to information collected through our Site and not to any information collected offline or through other channels. We reserve the right to update or modify this Privacy Policy at any time, and such changes will be effective immediately upon posting on this page. It is your responsibility to review this Privacy Policy periodically for any updates. If you have any questions or concerns about our Privacy Policy, please contact us at contact@resourcepal.io."
                }
              </div>
            </div>
          </div>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "header", "h1", "privacyPolicy", "footer"],
  header: ["header"],
  h1: ["h1"],
  privacyPolicy: ["privacyPolicy"],
  footer: ["footer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: typeof Header;
  h1: "h1";
  privacyPolicy: "div";
  footer: typeof Footer;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPrivacyPolicyPage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPrivacyPolicyPage__VariantsArgs;
    args?: PlasmicPrivacyPolicyPage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicPrivacyPolicyPage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicPrivacyPolicyPage__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicPrivacyPolicyPage__ArgProps,
          internalVariantPropNames: PlasmicPrivacyPolicyPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPrivacyPolicyPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPrivacyPolicyPage";
  } else {
    func.displayName = `PlasmicPrivacyPolicyPage.${nodeName}`;
  }
  return func;
}

export const PlasmicPrivacyPolicyPage = Object.assign(
  // Top-level PlasmicPrivacyPolicyPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    h1: makeNodeComponent("h1"),
    privacyPolicy: makeNodeComponent("privacyPolicy"),
    footer: makeNodeComponent("footer"),

    // Metadata about props expected for PlasmicPrivacyPolicyPage
    internalVariantProps: PlasmicPrivacyPolicyPage__VariantProps,
    internalArgProps: PlasmicPrivacyPolicyPage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicPrivacyPolicyPage;
/* prettier-ignore-end */
